import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Input, Spin, Space, Statistic } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import axios from "axios";
import log from "../utils/log";
import metaData from "../data/metaData";
import c from "../utils/common";

const { Countdown } = Statistic;

const OtpForm = ({ answer, isLoading, onCorrect, sendOTP }) => {
  const [isCoolDown, setIsCoolDown] = useState(false);

  return (
    <Row>
      <h1 style={{ width: "100%", marginTop: "1rem", marginBottom: "0.5rem", fontSize: "2rem" }}>Verify your email</h1>
      <Row style={{ fontSize: "0.75rem", color: "gray", fontSize: "1rem" }}>
        Enter the verification code sent to your email
      </Row>
      <Input.OTP
        style={{
          width: "100%",
          marginTop: "2rem",
          marginBottom: "2rem",
          fontWeight: "bold",
        }}
        length={4}
        size="large"
        formatter={(str) => str.toUpperCase()}
        onChange={(value) => {
          if (value == answer) {
            //correct
            onCorrect(value);
          } else {
            c.message({ type: "error", content: "wrong OTP, please check email again" });
          }
        }}
      />
      {isLoading ? <Spin indicator={<LoadingOutlined spin />} /> : null}
      <Row align="middle" style={{ width: "100%", fontSize: "1rem", color: "gray", marginTop: "2rem" }}>
        Haven't received the email?&nbsp;
        {isCoolDown ? (
          <Space style={{ marginLeft: "1rem", color: "var(--ion-color-step-400)" }}>
            <Countdown
              valueStyle={{ fontSize: "18px", color: "var(--ion-color-step-400)" }}
              value={Date.now() + 1000 * 30}
              onFinish={() => {
                setIsCoolDown(false);
              }}
              format="ss"
            />
            <span>s</span>
          </Space>
        ) : (
          <a
            onClick={() => {
              setIsCoolDown(true);
              sendOTP();
            }}
          >
            Send again
          </a>
        )}
      </Row>
    </Row>
  );
};

const useOtp = () => {
  const sendOTP = async (email) => {
    let _otp = c.random4Digit();

    let data = {
      to: email,
      otp: _otp,
    };
    log.debug(data);

    if (metaData.sendEmail) {
      await axios.post(metaData.serverURL + "sendEmail/OTP", data);
    }
    
    return _otp;
  };

  return { sendOTP, OtpForm };
};

export default useOtp;
